import './App.css';
import Main from "./components/Main";
import styled from "styled-components";
import Grid from "./components/Grid";
import VideoBcg from './components/VideoBcg';
import Video from "./components/Video";

function App() {
  return (
    <div>
      
      <Video />
    </div>
      
      
     
    
  );
}

export const AppWrapper = styled.div`


`;

export default App;
